/** 1.3.0 portal strings, stream P3 (the supplier's portal app; email.portal_submission_received.*, email.portal_qc_result.*). P3's file. */
export const PORTAL_APP_STRINGS = {
  // Shell and navigation
  'portal.myDeliveries': 'My deliveries',
  'portal.newUpload': 'New upload',
  'portal.myUploads': 'My uploads',
  'portal.help': 'Help',
  'portal.nav.label': 'Portal sections',
  'portal.signedInAs': 'Signed in as {name}, {company}',
  'portal.skipToContent': 'Skip to content',
  'portal.back': 'Back',
  'portal.notFound': 'This page is not here.',
  'portal.signInPending': 'Sign-in is being set up. Ask your PRISM contact for access.',
  'portal.welcomeDefault': 'Deliver your files to {workspace} here.',

  // My deliveries
  'portal.deliveries.empty': 'Nothing to deliver right now. New requests appear here and are emailed to you.',
  'portal.deliveries.due': 'Due {date}',
  'portal.deliveries.overdue': 'Overdue since {date}',
  'portal.deliveries.noDue': 'No due date',
  'portal.deliveries.itemsDone': '{done} of {total} items uploaded',
  'portal.deliveries.open': 'Open',
  'portal.delivery.spec': 'Delivery spec',
  'portal.delivery.notes': 'Notes from {workspace}',
  'portal.delivery.items': 'What to deliver',
  'portal.delivery.accepts': 'Accepts {types}',
  'portal.delivery.anyMedia': 'Accepts video, audio or image files',
  'portal.delivery.anyFile': 'Accepts any file',
  'portal.delivery.maxSize': 'up to {size}',
  'portal.delivery.naming': 'File name: {rule}',
  'portal.delivery.required': 'Required',
  'portal.delivery.optional': 'Optional',
  'portal.delivery.submitHint': 'Submit for review once the media is uploaded. Items you upload later are reviewed as they arrive.',
  'portal.delivery.submitted': 'Submitted for review. We will email you when it has been reviewed.',
  'portal.delivery.result': 'See the result',
  'portal.delivery.fields': 'Details',

  // States
  'portal.state.assignment.open': 'To do',
  'portal.state.assignment.in_progress': 'In progress',
  'portal.state.assignment.in_review': 'In review',
  'portal.state.assignment.accepted': 'Accepted',
  'portal.state.assignment.cancelled': 'Cancelled',
  'portal.state.assignment.expired': 'Expired',
  'portal.state.item.open': 'To upload',
  'portal.state.item.uploaded': 'Uploaded',
  'portal.state.item.accepted': 'Accepted',
  'portal.state.item.rejected': 'Changes needed',
  'portal.state.item.waived': 'Not needed',
  'portal.state.submission.draft': 'Not submitted',
  'portal.state.submission.waiting': 'In review',
  'portal.state.submission.needs_changes': 'Changes needed',
  'portal.state.submission.accepted': 'Accepted',
  'portal.state.submission.rejected': 'Rejected',
  'portal.state.submission.withdrawn': 'Withdrawn',
  'portal.state.submission.expired': 'Expired',
  'portal.state.processing.registered': 'Waiting to be processed',
  'portal.state.processing.processing': 'Processing',
  'portal.state.processing.ready': 'Processed',
  'portal.state.processing.partial': 'Processed with problems',
  'portal.state.processing.failed': 'Could not be processed',
  'portal.item.rejectedReason': 'Changes needed: {reason}',
  'portal.item.replace': 'Replace file',
  'portal.item.upload': 'Upload file',
  'portal.item.uploadAgain': 'Upload again',

  // Uploading
  'portal.upload.drop': 'Drop a file here or choose one',
  'portal.upload.dropMany': 'Drop files here or choose them',
  'portal.upload.choose': 'Choose file',
  'portal.upload.chooseMany': 'Choose files',
  'portal.upload.camera': 'Photo or video library',
  'portal.upload.progress': '{done} of {total}',
  'portal.upload.speed': '{speed}/s',
  'portal.upload.remaining': 'about {time} left',
  'portal.upload.checking': 'Checking the file…',
  'portal.upload.done': 'Uploaded',
  'portal.upload.cancel': 'Cancel upload',
  'portal.upload.paused': 'Connection lost. The upload continues when you are back online.',
  'portal.upload.retrying': 'Trying again…',
  'portal.upload.failed': 'The upload stopped: {message}',
  'portal.upload.resumeTitle': 'Finish an interrupted upload',
  'portal.upload.resumeBody': '“{name}” ({size}) was {percent} uploaded. Choose the same file to continue where it stopped.',
  'portal.upload.resumeChoose': 'Choose the file',
  'portal.upload.resumeDiscard': 'Discard',
  'portal.upload.resumeWrongFile': 'That is not the same file. Choose “{name}” ({size}).',
  'portal.upload.notScanned': 'Files are not virus-scanned on this portal yet.',
  'portal.upload.leaveWarning': 'An upload is still running. Leave anyway? You can continue it later.',

  // New upload (open uploads)
  'portal.open.title': 'New upload',
  'portal.open.intro': 'Upload clips and footage. Each file is reviewed before it is used.',
  'portal.open.introGrouped': 'Upload clips and footage. The files you upload together are reviewed together.',
  'portal.open.details': 'About these files',
  'portal.open.titleField': 'Title',
  'portal.open.start': 'Upload',
  'portal.open.notAllowed': 'Open uploads are not set up for you.',
  'portal.open.another': 'Upload more',
  'portal.open.sent': 'Uploaded. Each file is reviewed before it is used; see My uploads for the result.',
  'portal.uploads.empty': 'You have not uploaded anything yet.',

  // Rights declaration and submitting
  'portal.rights.title': 'Rights declaration',
  'portal.rights.accept': 'I confirm that I hold the rights to these files.',
  'portal.rights.default': 'I confirm that I hold, or have been granted, all rights needed for these files to be delivered and used.',
  'portal.submit': 'Submit for review',
  'portal.submit.needsMedia': 'Upload the media first.',
  'portal.required': 'required',
  'portal.fieldRequired': 'Fill in {field}.',

  // Withdraw
  'portal.withdraw': 'Withdraw',
  'portal.withdraw.title': 'Withdraw this submission?',
  'portal.withdraw.body': 'Its files are removed after a while and it is not reviewed. You can upload again afterwards.',
  'portal.withdraw.reason': 'Reason (optional)',
  'portal.withdraw.confirm': 'Withdraw',
  'portal.withdraw.done': 'Withdrawn.',

  // Result view
  'portal.result.title': 'Result',
  'portal.result.preview': 'Preview',
  'portal.result.noPreview': 'The preview is being made. It appears here when the file has been processed.',
  'portal.result.qc': 'Quality check',
  'portal.result.qcPending': 'The quality check runs after the file has been processed.',
  'portal.result.qcNone': 'No quality check for this file.',
  'portal.result.qcSummary': '{result}: {errors} errors, {warnings} warnings',
  'portal.result.findings': 'Findings',
  'portal.result.noFindings': 'No findings.',
  'portal.result.wholeFile': 'Whole file',
  'portal.result.jump': 'Play from {tc}',
  'portal.result.report': 'Download the QC report',
  'portal.result.files': 'Your files',
  'portal.result.rightsAccepted': 'Rights declaration accepted {date} (version {version})',
  'portal.qc.passed': 'Passed',
  'portal.qc.warnings': 'Passed with warnings',
  'portal.qc.failed': 'Failed',
  'portal.qc.error': 'Could not be checked',
  'portal.qc.queued': 'Waiting',
  'portal.qc.running': 'Checking',
  'portal.severity.error': 'Error',
  'portal.severity.warning': 'Warning',

  // Comments
  'portal.comments.title': 'Comments',
  'portal.comments.itemTitle': 'Comments on {item}',
  'portal.comments.empty': 'No comments yet.',
  'portal.comments.whole': 'On the whole delivery',
  'portal.comments.add': 'Comment on {item}',
  'portal.comments.placeholder': 'Write a comment or a reply',
  'portal.comments.send': 'Send',
  'portal.comments.reply': 'Reply',
  'portal.comments.you': 'You',
  'portal.comments.decision.accepted': 'Accepted',
  'portal.comments.decision.rejected': 'Changes needed',
  'portal.comments.decision.waived': 'Not needed',
  'portal.comments.decision.reopened': 'Opened again',
  'portal.comments.decision.withdrawn': 'Withdrawn',

  // Errors the portal names
  'portal.error.UPLOAD_TOO_LARGE': 'The file is too large for this item.',
  'portal.error.UNSUPPORTED_TYPE': 'This type of file is not accepted here.',
  'portal.error.NAMING_RULE': 'The file name does not follow the naming rule.',
  'portal.error.INTAKE_LOCATION_UNSET': 'Uploads are not open yet. Contact your PRISM contact.',
  'portal.error.SCANNER_UNAVAILABLE': 'The virus scanner is not available right now. Try again in a moment; the upload is kept.',
  'portal.error.INTAKE_MEDIA_REQUIRED': 'Upload the media first.',
  'portal.error.METADATA_REQUIRED': 'Fill in the required details.',
  'portal.error.UNAUTHENTICATED': 'Sign in again to continue.',
  'portal.error.NOT_FOUND': 'This is not here, or not yours to see.',

  // Supplier emails (P3's receipts)
  'email.portal_submission_received.subject': 'Received: {title}',
  'email.portal_submission_received.body': 'Hello {name},\n\nWe received “{title}” on {portalName}. It is now being reviewed; we will email you when it has been.\n\nSee its status: {link}',
  'email.portal_qc_result.subject': 'Quality check {result}: {title}',
  'email.portal_qc_result.body': 'Hello {name},\n\nThe automated quality check of “{title}” finished: {result}, with {errors} errors and {warnings} warnings.\n\nSee the findings and download the report: {link}',
} as const;
